import axios from 'axios';
import { baseURL } from '../config';
import { StorageKeys, Tokens, messages } from '../constants';
import { refreshToken } from './requests/refreshToken';
import KeycloakServices from '../Keycloak-config';
import { clearLocalStorage } from '../static/common';

const authToken = () => localStorage.getItem(Tokens.accessToken);

const clientId = () => localStorage.getItem(StorageKeys.clientId);

const userRole = () => localStorage.getItem(StorageKeys.userRole);

const client = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${authToken()}`,
    Accept: 'application/json'
  },
});

client.interceptors.request.use((config: any) => {
  config.headers.Authorization = `Bearer ${authToken()}`;
  if (clientId()) {
    config.headers[StorageKeys.clientId] = `${clientId()}`;
  }
  if (userRole()) {
    config.headers[StorageKeys.userRole] = `${userRole()}`;
  }
  return config;
});

client.interceptors.response.use((res) => res, async (err) => {
  const originalRequest = err.config;
  if (err?.response?.status === 401 && (err?.response?.data === messages.refreshTokenExpired || err?.response?.data === messages?.sessionNotActive
    || err?.response?.data === messages?.usernotFound || err?.response?.data === messages?.invalidRefreshToken || err?.response?.data === messages.tokenNotActive)) {
    clearLocalStorage();
    KeycloakServices.logout();
  } else if (err && err?.response && err?.response?.status === 401) {
    try {
      const refreshData = await refreshToken(localStorage.getItem(Tokens.refreshToken) as string);
      if (refreshData?.data?.accessToken) {
        localStorage.setItem(Tokens.accessToken, refreshData?.data?.accessToken);
        originalRequest.headers.Authorization = `Bearer ${refreshData.data.accessToken}`;
        return await client(originalRequest);
      }
    } catch {
      return true;
    }
  } else if (err && (err?.code === 'ERR_NETWORK')) {
    const restrictRedirectList = [
      'person',
      'transit',
      'truck'
    ];
    const isNotAllowedErrorPage = restrictRedirectList?.find((item: any) => window?.location?.href?.includes(item));
    if (!window.location.href?.includes('error') && !isNotAllowedErrorPage) {
      window.location.href = `${window?.location?.origin}/error`;
    }
  } else if (err && err?.response && (err?.response?.status === 502)) {
    const updatedError = {
      ...err,
      message: '502 Bad Gateway',
      response: {
        ...err?.response,
        data: '502 Bad Gateway'
      }
    };
    return Promise.reject(updatedError);
  }

  return Promise.reject(err);
});

export { client };
